export interface Hero {
  id: string
  name: string
  tagline: string
  traits: string[]
  color: string          // primary accent hex
  selectionMessage: string
  imagePlaceholder: string
}

export const HEROES: Hero[] = [
  {
    id: "superman",
    name: "Superman",
    tagline: "Man of Steel",
    traits: ["Strong Leader", "Upright", "Courageous"],
    color: "#1565C0",
    selectionMessage: "Truth, justice, and the pursuit of knowledge. I'll be with you every step of the way!",
    imagePlaceholder: "superman",
  },
  {
    id: "batman",
    name: "Batman",
    tagline: "Dark Knight",
    traits: ["Strategic", "Resilient", "Analytical"],
    color: "#212121",
    selectionMessage: "I became Batman because I refused to give up. Whatever you're studying — so can you.",
    imagePlaceholder: "batman",
  },
  {
    id: "iron-man",
    name: "Iron Man",
    tagline: "Genius Billionaire",
    traits: ["Innovative", "Confident", "Problem Solver"],
    color: "#B71C1C",
    selectionMessage: "Part of the journey is the end — but the best part is the learning along the way. Let's build something great.",
    imagePlaceholder: "iron-man",
  },
  {
    id: "spider-man",
    name: "Spider-Man",
    tagline: "Friendly Neighbourhood Hero",
    traits: ["Curious", "Responsible", "Quick Thinker"],
    color: "#E53935",
    selectionMessage: "With great power comes great responsibility. And with great study habits comes great results!",
    imagePlaceholder: "spider-man",
  },
  {
    id: "wonder-woman",
    name: "Wonder Woman",
    tagline: "Warrior Princess",
    traits: ["Bold", "Compassionate", "Wise"],
    color: "#AD1457",
    selectionMessage: "Be the hero you wish to see. I believe in your strength and your wisdom.",
    imagePlaceholder: "wonder-woman",
  },
  {
    id: "black-panther",
    name: "Black Panther",
    tagline: "King of Wakanda",
    traits: ["Visionary", "Disciplined", "Proud"],
    color: "#4A148C",
    selectionMessage: "Wakanda forever — and so is the pursuit of excellence. Let your knowledge be your vibranium.",
    imagePlaceholder: "black-panther",
  },
  {
    id: "captain-america",
    name: "Captain America",
    tagline: "First Avenger",
    traits: ["Honest", "Determined", "Team Player"],
    color: "#0D47A1",
    selectionMessage: "I can do this all day — and so can you. Never stop learning, never stop improving.",
    imagePlaceholder: "captain-america",
  },
  {
    id: "thor",
    name: "Thor",
    tagline: "God of Thunder",
    traits: ["Brave", "Loyal", "Powerful"],
    color: "#1976D2",
    selectionMessage: "Mjolnir chose me because I was worthy. Your curiosity makes you worthy of greatness.",
    imagePlaceholder: "thor",
  },
  {
    id: "hulk",
    name: "Hulk",
    tagline: "Strongest Avenger",
    traits: ["Tenacious", "Passionate", "Unstoppable"],
    color: "#2E7D32",
    selectionMessage: "Hulk always find way. And you will too — one lesson at a time.",
    imagePlaceholder: "hulk",
  },
  {
    id: "doctor-strange",
    name: "Doctor Strange",
    tagline: "Sorcerer Supreme",
    traits: ["Focused", "Intelligent", "Meticulous"],
    color: "#6A1B9A",
    selectionMessage: "I studied millions of futures. In all of them, those who commit to learning come out on top.",
    imagePlaceholder: "doctor-strange",
  },
  {
    id: "captain-marvel",
    name: "Captain Marvel",
    tagline: "Cosmic Avenger",
    traits: ["Fearless", "Resilient", "Independent"],
    color: "#C62828",
    selectionMessage: "I've been knocked down more times than I can count. I always get back up. So will you.",
    imagePlaceholder: "captain-marvel",
  },
  {
    id: "black-widow",
    name: "Black Widow",
    tagline: "Master of Espionage",
    traits: ["Strategic", "Adaptable", "Resourceful"],
    color: "#B71C1C",
    selectionMessage: "I have a lot of red in my ledger — but I'm here to help you write a story worth telling.",
    imagePlaceholder: "black-widow",
  },
  {
    id: "scarlet-witch",
    name: "Scarlet Witch",
    tagline: "Mistress of Magic",
    traits: ["Creative", "Empathetic", "Powerful"],
    color: "#880E4F",
    selectionMessage: "Your potential is limitless. I've seen what happens when someone believes in themselves fully.",
    imagePlaceholder: "scarlet-witch",
  },
  {
    id: "storm",
    name: "Storm",
    tagline: "Omega Level Mutant",
    traits: ["Graceful", "Commanding", "Principled"],
    color: "#0277BD",
    selectionMessage: "I was once a goddess. But first, I was a student. Your journey starts here.",
    imagePlaceholder: "storm",
  },
  {
    id: "green-lantern",
    name: "Green Lantern",
    tagline: "Emerald Knight",
    traits: ["Willful", "Creative", "Courageous"],
    color: "#2E7D32",
    selectionMessage: "My ring is powered by willpower. Your pen is powered by the same thing. Use it.",
    imagePlaceholder: "green-lantern",
  },
  {
    id: "the-flash",
    name: "The Flash",
    tagline: "Fastest Man Alive",
    traits: ["Quick Learner", "Optimistic", "Energetic"],
    color: "#E65100",
    selectionMessage: "Speed is great, but understanding is better. I'm the fastest, and I never stop learning.",
    imagePlaceholder: "the-flash",
  },
  {
    id: "aquaman",
    name: "Aquaman",
    tagline: "King of Atlantis",
    traits: ["Persistent", "Adaptable", "Natural Leader"],
    color: "#006064",
    selectionMessage: "I ruled two worlds by refusing to be limited by where I came from. So can you.",
    imagePlaceholder: "aquaman",
  },
  {
    id: "hawkgirl",
    name: "Hawkgirl",
    tagline: "Winged Warrior",
    traits: ["Fierce", "Loyal", "Perceptive"],
    color: "#F57F17",
    selectionMessage: "I've fought across centuries. Every lifetime, I've learned something new. This is yours.",
    imagePlaceholder: "hawkgirl",
  },
  {
    id: "shuri",
    name: "Shuri",
    tagline: "Princess of Wakanda",
    traits: ["Brilliant", "Innovative", "Playful"],
    color: "#6A1B9A",
    selectionMessage: "What are sneakers? That's not important. What's important is what you build with your mind.",
    imagePlaceholder: "shuri",
  },
  {
    id: "miles-morales",
    name: "Miles Morales",
    tagline: "Spider-Man of Brooklyn",
    traits: ["Creative", "Determined", "Authentic"],
    color: "#1A237E",
    selectionMessage: "Anyone can wear the mask. Including you. Your story is only beginning.",
    imagePlaceholder: "miles-morales",
  },
  {
    id: "ms-marvel",
    name: "Ms. Marvel",
    tagline: "Stretchy Superhero",
    traits: ["Enthusiastic", "Empathetic", "Community-Focused"],
    color: "#E91E63",
    selectionMessage: "I'm just a girl from Jersey who refused to let her dreams stay small. Neither should you.",
    imagePlaceholder: "ms-marvel",
  },
  {
    id: "wolverine",
    name: "Wolverine",
    tagline: "The Best There Is",
    traits: ["Persistent", "Instinctive", "Protective"],
    color: "#F9A825",
    selectionMessage: "I've lived a hundred lifetimes. The lesson I keep learning? Never stop growing.",
    imagePlaceholder: "wolverine",
  },
  {
    id: "ant-man",
    name: "Ant-Man",
    tagline: "Size-Shifting Avenger",
    traits: ["Clever", "Humble", "Inventive"],
    color: "#E65100",
    selectionMessage: "I proved that the smallest ideas can have the biggest impact. So can yours.",
    imagePlaceholder: "ant-man",
  },
  {
    id: "wasp",
    name: "Wasp",
    tagline: "Founding Avenger",
    traits: ["Sharp", "Stylish", "Decisive"],
    color: "#F9A825",
    selectionMessage: "People underestimate me all the time. I use that to my advantage. You should too.",
    imagePlaceholder: "wasp",
  },
  {
    id: "cyborg",
    name: "Cyborg",
    tagline: "Man and Machine",
    traits: ["Logical", "Adaptable", "Driven"],
    color: "#37474F",
    selectionMessage: "My greatest upgrade wasn't technological. It was learning to believe in myself. Boom, I'll show you how.",
    imagePlaceholder: "cyborg",
  },
  {
    id: "nightwing",
    name: "Nightwing",
    tagline: "Defender of Blüdhaven",
    traits: ["Agile", "Charismatic", "Disciplined"],
    color: "#0D47A1",
    selectionMessage: "I stepped out of Batman's shadow by being exactly who I am. You should do the same.",
    imagePlaceholder: "nightwing",
  },
  {
    id: "rogue",
    name: "Rogue",
    tagline: "Southern Belle Mutant",
    traits: ["Self-Reliant", "Tenacious", "Empathetic"],
    color: "#2E7D32",
    selectionMessage: "I had to learn everything the hard way, on my own. But that made me who I am. You've got help — use it.",
    imagePlaceholder: "rogue",
  },
  {
    id: "zatanna",
    name: "Zatanna",
    tagline: "Mistress of Magic",
    traits: ["Disciplined", "Creative", "Focused"],
    color: "#4A148C",
    selectionMessage: "Magic requires precision, practice, and patience — exactly what great study habits are made of.",
    imagePlaceholder: "zatanna",
  },
]
